//   $(document).ready(function(){
   
//       setTimeout(function() {
      
//      alert("hii")
//      $('.testimonials-list').flickity({
//       // options
//       cellAlign: 'left',
//       contain: true
//     });
//   },5000);

//  });


  $(document).ready(function(){
    var checkWidth = $(window).width();

    if (checkWidth > 767) {
      $(".testimonials-list").owlCarousel(
        {
              navigation : true,//Set AutoPlay to 3 seconds
              items : 4,
              itemsDesktop : [1199,3],
              itemsDesktopSmall : [979,3]

          }
          );
        $( ".owl-prev").html('<svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z" class="arrow"></path></svg>');
        $( ".owl-next").html('<svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z" class="arrow"></path></svg>');
      }
    }); 


$(document).on("change",".product-single__variants",function(t){$("#add-to-cart-cstm").attr("data-id",$(this).val())}),$("body").delegate("#add-to-cart-cstm","click",function(){location.href=($(this).data("shopurl")+"/cart/"+$(this).attr("data-id")+":"+$("#product-quantity-select").val())??1});